export const TEXT_PLACEHOLDER = 'Your Text Here';
export const MONOGRAM_PLACEHOLDER = 'ABC';
export const JERSEY_NAME_PLACEHOLDER = 'Your Name';
export const JERSEY_NUMBER_PLACEHOLDER = '00';
export const NAME_PLACEHOLDER = 'Name';
export const TITLE_PLACEHOLDER = 'Title';

export const DEFAULT_COLOR = '#000000';
export const DEFAULT_COLOR_DARK = '#000000';
export const DEFAULT_COLOR_LIGHT = '#ffffff';

// 150 DPI is about minimum resolution that doesn't look too pixelated
// 300 DPI looks fine. Both evenly divide the printer's resolution of 1200x600 DPI.
export const MINIMUM_BITMAP_DPI = 150.0;
export const MINIMUM_BITMAP_SIZE_INCHES = 0.25;

export type DefaultColor = { print: string; display: string; original?: string; name: string };
export const DEFAULT_COLORS: DefaultColor[] = [
  { print: '#bc004c', display: '#9c1a28', original: '#f44336', name: 'Dark Red' },
  { display: '#e91e63', print: '#e91e63', name: 'Magenta' },
  { display: '#9c27b0', print: '#9c27b0', name: 'Purple' },
  { display: '#673ab7', print: '#673ab7', name: 'Dark Purple' },
  { display: '#4251af', print: '#4251af', name: 'Dark Blue' },
  { display: '#2196f3', print: '#2196f3', name: 'Blue' },
  { display: '#4ba7ee', print: '#4ba7ee', name: 'Light Blue' },
  { display: '#54B9d1', print: '#54B9d1', name: 'Bright Blue' },
  { print: '#37BCBB', display: '#57B3A4', original: '#009688', name: 'Teal' },
  { display: '#66AD5B', print: '#66AD5B', name: 'Green' },
  { display: '#96C05C', print: '#96C05C', name: 'Light Green' },
  { display: '#D0DA59', print: '#D0DA59', name: 'Lime Green' },
  { display: '#FCEC60', print: '#FCEC60', name: 'Yellow' },
  { display: '#F6C343', print: '#F6C343', name: 'Light Orange' },
  { print: '#FF6537', display: '#FF6D1D', original: '#ff5722', name: 'Orange' },
  { display: '#74564A', print: '#74564A', name: 'Brown' },
  { display: '#667C88', print: '#667C88', name: 'Blue Grey' },
  { display: '#000000', print: '#000000', name: 'Black' },
  { display: '#333333', print: '#333333', name: 'Dark Grey' },
  { display: '#666666', print: '#666666', name: 'Grey' },
  { display: '#999999', print: '#999999', name: 'Medium Grey' },
  { display: '#cccccc', print: '#cccccc', name: 'Light Grey' },
  { display: '#ffffff', print: '#ffffff', name: 'White' },
].map((color: DefaultColor) => {
  return {
    name: color.name,
    print: color.print.toLowerCase(),
    display: color.display.toLowerCase(),
    original: color.original?.toLowerCase(),
  };
});
